import { render, staticRenderFns } from "./CreateNomenclatureModifier.vue?vue&type=template&id=5b44aa64&scoped=true"
import script from "./CreateNomenclatureModifier.vue?vue&type=script&lang=js"
export * from "./CreateNomenclatureModifier.vue?vue&type=script&lang=js"
import style0 from "./CreateNomenclatureModifier.vue?vue&type=style&index=0&id=5b44aa64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b44aa64",
  null
  
)

export default component.exports